export function conditionalWaitedPolling<T extends () => any>(timeout: number, action: T, condition: (data: Awaited<ReturnType<T>>) => boolean) {
  return new Promise<Awaited<ReturnType<T>>>((resolve, reject) => {
    async function handler() {
      const data = await action();

      if (condition(data)) return resolve(data);

      setTimeout(async () => {
        try {
          await handler();
        } catch (error) {
          reject(error);
        }
      }, timeout);
    }

    handler().catch(reject);
  });
}
